import { CHNANGE_LISTVIEW_TAB } from "./actionTypes";

export const changeListViewTab = (indexTab) => {
  return {
    type: CHNANGE_LISTVIEW_TAB,
    payload: indexTab,
  };
};
